import { GlobalFooter, Navigation } from '@pkdigital/pkd-custom-components';
import React from 'react';
import { BottomFooterLinks } from './index';

const PortraitFooter: React.FC = () => {
  return (
    <GlobalFooter
      className={'pkd-footer'}
      logoLink={{ href: '/td-home/images/techemlogo-white.svg' }}
      navigationComponent={<FooterNavigation />}
    />
  );
};

const FooterNavigation = () => {
  const items = BottomFooterLinks.slice(0, BottomFooterLinks.length - 1).map((linkData) => {
    return { link: { href: linkData.url }, title: linkData.displayName };
  });

  return <Navigation items={items} />;
};

export { PortraitFooter };
